import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.SurveyItemChartView extends Monitoring.Views.Charts.ChartView

  _itemTerms: (survey, itemCode) ->
    for code, item of survey.items
      return item.terms if code == itemCode
